import { Controller } from '@hotwired/stimulus'
import { stimulus } from '~/init'

export default class ScheduleMonthController extends Controller {
  static targets = [
    'cell',
    'checkbox',
    'form',
    'startsAt',
    'endsAt',
    'breakStartsAt',
    'breakEndsAt',
    'timeRow'
  ]

  static values = {
    conflictWarning: String,
    copyUrl: String,
    copyOverwriteConfirm: String
  }

  toggleCell (event) {
    const td = event.currentTarget
    const input = td.querySelector('input[type="hidden"]')
    const mark = td.querySelector('.schedule-month__cell-mark')
    const hasConflict = td.dataset.hasConflict === 'true'
    const isActive = input.value === '1'

    if (isActive && hasConflict) {
      if (!window.confirm(this.conflictWarningValue)) return
    }

    if (isActive) {
      input.value = '0'
      td.classList.remove('schedule-month__td--active')
      mark.textContent = ''
    } else {
      input.value = '1'
      td.classList.add('schedule-month__td--active')
      mark.textContent = '■'
    }
  }

  copyTimesToAll (event) {
    const sourceMechanicId = event.currentTarget.dataset.mechanicId
    const sourceRow = this.timeRowTargets.find(
      row => row.dataset.mechanicId === sourceMechanicId
    )
    if (!sourceRow) return

    const sourceStartsAt = sourceRow.querySelector('[data-schedule-month-target="startsAt"]').value
    const sourceEndsAt = sourceRow.querySelector('[data-schedule-month-target="endsAt"]').value
    const sourceBreakStartsAt = sourceRow.querySelector('[data-schedule-month-target="breakStartsAt"]').value
    const sourceBreakEndsAt = sourceRow.querySelector('[data-schedule-month-target="breakEndsAt"]').value

    this.timeRowTargets.forEach(row => {
      if (row.dataset.mechanicId === sourceMechanicId) return
      if (row.dataset.rowRole !== 'mechanic') return

      row.querySelector('[data-schedule-month-target="startsAt"]').value = sourceStartsAt
      row.querySelector('[data-schedule-month-target="endsAt"]').value = sourceEndsAt
      row.querySelector('[data-schedule-month-target="breakStartsAt"]').value = sourceBreakStartsAt
      row.querySelector('[data-schedule-month-target="breakEndsAt"]').value = sourceBreakEndsAt
    })
  }

  copyWeek (event) {
    event.preventDefault()

    const btn = event.currentTarget
    const targetStart = btn.dataset.targetStart
    const targetStartDate = new Date(targetStart)
    const targetEndDate = new Date(targetStartDate)
    targetEndDate.setDate(targetEndDate.getDate() + 6)

    // Check if any cells in the target week are active
    const hasExisting = this.cellTargets.some(cell => {
      const dayNum = parseInt(cell.dataset.day, 10)
      // Build date from the month context (year/month from the form)
      const formYear = this.formTarget.querySelector('input[name="year"]').value
      const formMonth = this.formTarget.querySelector('input[name="month"]').value
      const cellDate = new Date(formYear, formMonth - 1, dayNum)

      if (cellDate < targetStartDate || cellDate > targetEndDate) return false

      const input = cell.querySelector('input[type="hidden"]')
      return input && input.value === '1'
    })

    let mode = 'merge'
    if (hasExisting) {
      const confirmed = window.confirm(this.copyOverwriteConfirmValue)
      mode = confirmed ? 'overwrite' : 'merge'
    }

    // Submit via dynamic form
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = this.copyUrlValue

    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    if (csrfToken) {
      const csrfInput = document.createElement('input')
      csrfInput.type = 'hidden'
      csrfInput.name = 'authenticity_token'
      csrfInput.value = csrfToken
      form.appendChild(csrfInput)
    }

    const targetInput = document.createElement('input')
    targetInput.type = 'hidden'
    targetInput.name = 'target_start'
    targetInput.value = targetStart
    form.appendChild(targetInput)

    const modeInput = document.createElement('input')
    modeInput.type = 'hidden'
    modeInput.name = 'mode'
    modeInput.value = mode
    form.appendChild(modeInput)

    document.body.appendChild(form)
    form.requestSubmit()
    form.addEventListener('turbo:submit-end', () => form.remove())
  }

  submit () {
    this.formTarget.requestSubmit()
  }
}

stimulus.register('schedule-month', ScheduleMonthController)
